(function (TIPTOE, w, d, $, undefined) {
  /** @type {Function} Custom logger */
  const log = TIPTOE.HAS_DEBUG ? window.console.log.bind(window, 'Menu:') : function () {};

  const $body = $('body');
  const $header = $('.header');
  const $topHeader = $('.top-header--first');
  const $headerNav = $('[data-menu]');

  const topHeaderHeight = $topHeader.is(':visible') ? $topHeader.innerHeight() : 0;
  const headerHeight = $header.innerHeight();
  let currentSubmenu = null;
  let submenuIsOpen = false;

  $headerNav.on('mouseover', function () {
    $('.header__menu-btn--current').removeClass('header__menu-btn--current');
    $(this).parent().addClass('header__menu-btn--current');
  });

  $('[data-menu]').on('mouseover', function () {
    const menu = $(this).data('menu');
    const submenu = $(`#${menu}`);

    if (menu == 'shop') {
      $('.header__nav-wrapper').addClass('header__nav-wrapper--show');
    }

    if (!submenu && currentSubmenu) {
      currentSubmenu.removeClass('submenu--open');
      return;
    }

    if (currentSubmenu == submenu) {
      return;
    }

    if (currentSubmenu) {
      currentSubmenu.removeClass('submenu--open');
    }

    currentSubmenu = submenu;
    $(`#${menu}`).addClass('submenu--open');
  });

  $('.header__nav').on('mouseenter', function () {
    submenuIsOpen = true;
  });

  $('.header__nav').on('mouseleave', function () {
    submenuIsOpen = false;
  });

  $('.submenu--cards').on('mouseleave', function () {
    currentSubmenu.removeClass('submenu--open');
    $('.header__menu-btn--current').removeClass('header__menu-btn--current');
    $('[data-menu="shop"]').addClass('header__menu-btn--current');
  });

  $('.header__mobile-title').on('click', function () {
    $('.header__nav-wrapper').scrollTop(0);

    if ($(this).next('.submenu').length > 0) {
      $(this).next('.submenu').toggleClass('submenu--open');
      $body.toggleClass('submenuIsOpen');
    } else {
      $(this).next('.nav-main').toggleClass('nav-main--hide');
      $('.header__arrow-shop').toggleClass('rotate');
    }
  });

  /**
   * Gestion du sticky header
   * @returns void
   */
  $(window).on('scroll', function (event) {
    if ($(this).scrollTop() > topHeaderHeight) {
      if (!submenuIsOpen) {
        $header.addClass('header--sticky');
        $('.header__nav-wrapper--show').removeClass('header__nav-wrapper--show');
      }
    } else {
      $header.removeClass('header--sticky');
    }
  });

  // MOBILE //

  /**
   * Ouverture/Fermeture du menu
   * @returns void
   */
  $('.js-mobile-menu').on('click', function () {
    $body.toggleClass('menuIsOpen');
    closeSubmenu();
  });

  /**
   * Gestion de l'ouverture du sous-menu en mobile et tablette
   * @returns void
   */
  $('.is-tablet .menu__link--submenu, .is-mobile .menu__link--submenu').on(
    'click',
    function (event) {
      event.preventDefault();
      $('.header__nav-wrapper').scrollTop(0);
      $body.addClass('submenuIsOpen');
      $(this).prev('.submenu').addClass('submenu--open');
    },
  );

  /**
   * Click sur le sus-titre des sous-menu
   * @returns void
   */
  $('.submenu__mobile-button').on('click', function () {
    closeSubmenu();
  });

  /**
   * Ferme le sous-menu
   * @returns void
   */
  function closeSubmenu() {
    $('.submenu--open').removeClass('submenu--open');
    $body.removeClass('submenuIsOpen');
  }
})(TIPTOE, window, document, jQuery);
